import { render } from "./AddInventoryModal.vue?vue&type=template&id=3b6b7524"
import script from "./AddInventoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddInventoryModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Inventory/AddInventoryModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b6b7524"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b6b7524', __exports__)) {
    api.reload('3b6b7524', __exports__)
  }
  
  module.hot.accept("./AddInventoryModal.vue?vue&type=template&id=3b6b7524", () => {
    api.rerender('3b6b7524', render)
  })

}


export default __exports__